import { useEffect, useState } from "react";
import { _DodoDocs } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { DodoDoc } from "./DodoDoc";

export const SearchRadicate = () => {

    // getFormData			    ok
    // getRenderFormInputs      ok
    // getFormInputs			ok		
    // getFormFieldOptions		ok
    // getDirectoryList		    ok
    // getFiledListByDirectory	ok
    // getCodeServiceDodo		ok
    // formInsert			
    // formAttachFiles		    
    // formGetBase64StringFile	

    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_DodoDocs);
    const [inputs, setInputs] = useState<any>([]);
    const [response, setResponse] = useState<any>({});
    const [columns, setColumns] = useState<any>([]);
    const [criterio, setCriterio] = useState<any>([
        {ope:'=',valor:'Es igual a'},
        {ope:'Like',valor:'Contiene'},
        {ope:'>=',valor:'Mayor igual'},
        {ope:'<=',valor:'Menor igual'},
    ]);

    useEffect(()=>{

        setBean({Operador:'='});

        return () => setBean({Operador:'='})
    },[])
    useEffect(()=>{
        setResponse({});
        setColumns([]);
        setInputs([]);
    },[bean.formCode])

    useEffect(()=>{

        if(inputs.length>0)
        {
            let  tmp = inputs.filter(item=> item.DataBeanProperties.Required);
            let col = ["Cod_Barras"];
            tmp.forEach(element => {
                col.push(element.DataBeanProperties.Column);
            });
            setColumns(col);
        }

    },[inputs])

    const getRenderFormInputs = () => {
        if (bean.formCode) {
            instance.getFormInputs(bean.formCode + "").then(
                (resp: any) => {
                    console.log(resp);
                    if (resp.Column) {
                        if (resp.Column.length > 0) {
                            let tmp = resp.Column[0].DataBeanProperties;
                            setBean({ ...bean, "Camp": "Cod_Barras" });
                            setInputs(resp.Column);
                        }else{
                            setInputs([]);
                        }
                    }

                }
            )
        } else {
            toast.warning("Codigo de formulario no valido");
        }
    }

    const getFormData = () => {
        instance.getFormData(bean.formCode+"", bean.Camp, bean.Valor+"", bean.Operador).then(
            (resp: any) => {
                setResponse(resp);
            }
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-md-2">
                    <label>No Formulario</label>
                    <input type="text" name="formCode" className="form-control" value={bean.formCode} onChange={handleChange} />
                </div>
                <div className="col-md-2">
                    <BasicButton icon="ri-file-search-fill" clase="primary mbtn" eventClick={getRenderFormInputs}>Cargar</BasicButton>
                </div>
                {inputs.length > 0 &&
                    <>
                        <div className="col-md-2">
                            <label>Campo</label>
                            <select className="form-select" name="Camp" value={bean.Camp} onChange={handleChange}>
                                <option value={'Cod_Barras'}>No. Radicado</option>
                                {inputs.map((row: any, index: number) => {
                                    return (
                                        <option value={row.DataBeanProperties.Column}>{row.DataBeanProperties.Name}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label>Operador</label>
                            <select className="form-select" name="Operador" value={bean.Operador} onChange={handleChange}>
                                {criterio.map((row: any, index: number) => {
                                    return (
                                        <option value={row.ope}>{row.valor}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label>Valor</label>
                            <input type="text" name="Valor" className="form-control" value={bean.Valor} onChange={handleChange} />
                        </div>
                        <div className="col-md-2">
                            <BasicButton icon="ri-file-search-fill" clase="primary mbtn" eventClick={getFormData}>Buscar</BasicButton>
                        </div>

                    </>
                }

            </div>
            <div className="row">
                <div className="col-md-12">
                    {response.Message === 'OK' &&
                    <DodoDoc formCode={bean.formCode+""} camp={bean.Camp} value={bean.Valor+""} operator={bean.Operador} columns={columns} />
                    }
                </div>
            </div>
            {/* <div className="row">
                <div className="col-md-12">
                    <PrintJson json={bean} />
                    <PrintJson json={response} />
                </div>
            </div> */}
        </>
    )
}